import React from "react";

/**
 * Horizontally scrollable filter row. "Top sellers" comes first because it is
 * where most taps land during a rush.
 */
const CategoryChips = ({ chips, activeChip, onSelect }) => (
  <div className="flex gap-2 overflow-x-auto pb-1 -mx-3 px-3 sm:mx-0 sm:px-0 [scrollbar-width:none] [&::-webkit-scrollbar]:hidden">
    {chips.map((chip) => {
      const isActive = chip.id === activeChip;

      return (
        <button
          key={chip.id}
          type="button"
          onClick={() => onSelect(chip.id)}
          className={`shrink-0 h-10 px-4 rounded-full text-sm font-semibold whitespace-nowrap border transition-all active:scale-95 ${
            isActive
              ? "bg-primary-500 border-primary-400 text-white shadow-lg shadow-primary-500/20"
              : "bg-slate-900 border-slate-700 text-slate-300 hover:bg-slate-800 hover:text-white"
          }`}
        >
          {chip.icon && <span className="me-1.5">{chip.icon}</span>}
          {chip.label}
          <span
            className={`ms-2 text-xs tabular-nums ${
              isActive ? "text-primary-100" : "text-slate-500"
            }`}
          >
            {chip.count}
          </span>
        </button>
      );
    })}
  </div>
);

export default CategoryChips;
